"use strict";

export function init () {
    import('iframe-resizer').then(function (a) {
        a.iframeResizer();
    });
}